<template>
  <div>
      <b-card>
          <b-row>
              <b-col md="6">
                <h3>{{ $route.name }}</h3>

                <!-- breadcrumb -->
                <b-breadcrumb>
                <b-breadcrumb-item
                    ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
                >
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
                <!-- end breadcrumb -->
              </b-col>
              <b-col md="6"></b-col>
          </b-row>
          <hr>
          <form v-on:submit.prevent="onViewData()">
            <b-row class="align-items-center mt-4">
                <b-col md="1">
                    <h6 class="text-bold">Period</h6>
                </b-col>
                <b-col md="2">
                    <b-form-datepicker id="ledger-datepicker" v-model="model.startDate" class="mb-2"></b-form-datepicker>
                </b-col>
                <h6 class="text-bold">to</h6>
                <b-col md="2">
                    <b-form-datepicker id="datepicker" v-model="model.endDate" class="mb-2"></b-form-datepicker>
                </b-col>
            </b-row>
            <b-row v-if="model.startDate !==''">
                <b-col md="6" class="text-center">
                    <i class="font-weight-medium">Accounting Period :  <span class="text-bold">{{model.startDate !== '' ? getDateTime(model.startDate) : ' '}}</span> to <span class="text-bold">{{model.endDate !== '' ? getDateTime(model.endDate) : ' '}}</span></i>          
                </b-col>

            </b-row>
            <b-row class="mt-3 mb-3 align-items-center">
                <b-col md="1">
                    <h6 class="text-bold">Account</h6>
                </b-col>
                <b-col md="3">
                    <v-select
                        id="mySelect"
                        label="text"
                        v-model="model.journalAccount"
                        :options="dataAccountName"
                        :reduce="(text) => text.value"
                        class=""
                        placeholder="select journal account"
                        >
                        <template #search="{attributes, events}">
                            <input
                            class="vs__search"
                            :required="!model.journalAccount"
                            v-bind="attributes"
                            v-on="events"
                            />
                        </template>
                        </v-select>
                </b-col>
                <b-col md="2">
                    <b-button type="submit" variant="success" size="md" >
                        <i class="fas fa-play-circle"></i>
                        Process</b-button>
                </b-col>
            </b-row>
          </form>
         <div class="mt-5 mb-3 w-25">
            <b-card-group deck>
            <b-card bg-variant="light" header="" class="text-left" v-for="i in info" :key="i.cur">
                <b-card-text class="text-bold labels">Currency: <span class="text-success ml-3"> {{ i.cur}} </span></b-card-text>
                <b-card-text class="text-bold labels">Initial Balance: <span class="text-success ml-3"> {{ formatPrice(i.bal)}} </span></b-card-text>
                <b-card-text class="text-bold labels">Balance Now: <span class="text-success ml-3"> {{ formatPrice(i.balNow)}} </span></b-card-text>
            </b-card>
            </b-card-group>
        </div>
        <b-table
            id="my-table"
            :items="items"
            :busy="isLoading"
            :fields="fields"
            responsive
            center
            show-empty
            class="text-left mt-4 mb-5 justify-content-center"
            >
            <template v-slot:table-busy>
            <div class="text-center" style="margin: 3% auto;">
                <b-spinner small type="grow" label="Small Spinner"></b-spinner>
                <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
                <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
            </div>
            </template>
            <template #cell(createdAt)="row">
                <div class="text-center">
                {{ row.item.clockIn !== null ? getDateTime(row.item.createdAt) : '-' }}
                </div>
            </template>
            <template #cell(journalDebit)="row">
                <div class="text-center">
                {{ row.item.journalDebit !== null ? formatPrice(row.item.journalDebit) : '-' }}
                </div>
            </template>
            <template #cell(journalCredit)="row">
                <div class="text-center">
                {{ row.item.journalCredit !== null ? formatPrice(row.item.journalCredit) : '-' }}
                </div>
            </template>
            <template #cell(balance)="row">
                <div class="text-center">
                {{ row.item.balance !== null ? formatPrice(row.item.balance) : '-' }}
                </div>
            </template>
            <template #cell(numberTransaction)="row">
                <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'KSIN'">
                    <b-link class="text-primary" :href="'#' + '/accounting/cash-in' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'KASO'">
                    <b-link class="text-primary" :href="'#' + '/accounting/cash-out' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'KASTR'">
                    <b-link class="text-primary" :href="'#' + '/accounting/cash-transfer' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'STI'">
                    <b-link class="text-primary" :href="'#' + '/inventory/stock-in' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'STO'">
                    <b-link class="text-primary" :href="'#' + '/inventory/stock-out' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'R'">
                    <b-link class="text-primary" :href="'#' + '/new-reimbursement/history-reimbursement' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                 <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'PO'">
                    <b-link class="text-primary" :href="'#' + '/inventory/purchase' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                 <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'INV'">
                    <b-link class="text-primary" :href="'#' + '/sales/invoice' + '/' + row.item.journalReferenceUuid">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
                 <div class="text-left text-bold" v-if="row.item.journalReferenceType === 'DO'">
                    <b-link class="text-primary" :href="'#' + '/sales/delivery-order' + '/' + row.item.journalReferenceUuid ">
                     {{ row.item.numberTransaction !== null ? row.item.numberTransaction : '-' }}
                    </b-link>
                </div>
            </template>
         </b-table>
         <b-row class="mt-5 mb-1">
             <b-col md="3" class="d-flex align-items-center">
                 <label for="" class="labels">Debit Total:</label>
                 <div>
                    <money
                        v-model="debitTotal"
                        readonly
                        required
                        class="text-center bg-white form-control w-75 ml-3 text-right"
                        style="text-align: right !important"
                        placeholder="Price"
                        />

                 </div>
             </b-col>
             <b-col md="3" class="d-flex align-items-center">
                 <label for="" class="labels">Beginning Balance:</label>
                 <div>
                 <money
                    v-model="beginningBalanceTotal"
                    readonly
                    required
                    class="text-center bg-white form-control w-75 ml-2 text-right"
                    style="text-align: right !important"
                    placeholder="Price"
                    />
                 </div>
             </b-col>
         </b-row>
         <b-row class=" mb-5">
             <b-col md="3" class="d-flex align-items-center" >
                 <label for="" class="labels">Credit Total:</label>
                 <div>
                 <money
                    v-model="creditTotal"
                    readonly
                    required
                    class="text-center bg-white form-control w-75 ml-2 text-right"
                    style="text-align: right !important"
                    placeholder="Price"
                    />

                 </div>
             </b-col>
             <b-col md="3" class="d-flex align-items-center">
                 <label for="" class="labels mr-4">Ending Balance:</label>
                 <div>
                 <money
                    v-model="endingBalanceTotal"
                    readonly
                    required
                    class="text-center bg-white form-control w-75 ml-2 text-right"
                    style="text-align: right !important"
                    placeholder="Price"
                    />
                 </div>
             </b-col>
             <b-col md="2" class="mr-5">
                 <b-button :disabled="!disable" variant="warning" @click="doPrint()" class="text-bold ml-2">
                     <font-awesome-icon icon="print" />
                     Print</b-button>
             </b-col>
         </b-row>
      </b-card>
  </div>
</template>

<script>
import { Money } from 'v-money';
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
export default {
    components: {Money},
    data(){
        return {
            isLoading: false,
             apiUrl: {
                journal: window.AppConfig.apiUrl + 'journal-account?journalAccountType=D&isBank=1',
                ledger: window.AppConfig.apiUrl + 'get-ledger',
                exportLedger: window.AppConfig.apiUrl + 'export-ledger-pdf'
            },
            token: this.$store.getters['account/tokens'].access_token,
            model: {
                startDate: '',
                endDate: '',
                journalAccount: ''
            },
            dataAccountName : [],
            info: [],
            items: [],
            credit: [],
            debit: [],
            creditTotal: 0,
            debitTotal: 0,
            beginningBalanceTotal: 0,
            endingBalanceTotal: 0,
            totalTransaction: [],
            totalBegin: [],
             //formatter curency
            money: {
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
                },
            fields: [
                {
                    key: 'numberTransaction',
                    label: 'Transaction Number'
                },
                {
                    key: 'createdAt',
                    label: 'Date',
                    class: 'text-center'
                },
                {
                    key: 'journalNote',
                    label: 'Description',
                    class: 'text-center'
                },
                {
                    key: 'journalDebit',
                    label: 'Debit',
                    class: 'text-center'
                },
                {
                    key: 'journalCredit',
                    label: 'Credit',
                    class: 'text-center'
                },
                {
                    key: 'balance',
                    label: 'Balance',
                    class: 'text-center'
                },
            ]
        }
    },

    computed: {
    disable() {
      if (this.beginningBalanceTotal > 0) {
        return true;
      }
      return false;
    },
  },

    mounted() {
        this.getJournal()
        
    },

    methods: {
     onViewData(){
        this.$http.get(this.apiUrl.ledger + '?start_date=' + this.model.startDate + '&end_date=' + this.model.endDate + '&journal_account=' + this.model.journalAccount + '&token=' + this.token ).then(response => {
            this.items = response.data.trx
            this.info = response.data.info.map((d) => ({
                cur: d.currency,
                bal: d.journalAccountBalance,
                balNow: d.journalAccountBalanceNow
            }))
            this.totalTransaction = response.data.trx.forEach(trx => {
                this.creditTotal += trx.journalCredit;
                this.debitTotal += trx.journalDebit;
            })
            this.totalBegin = response.data.info.forEach(i => {
                this.beginningBalanceTotal += i.journalAccountBalance;
                this.endingBalanceTotal += i.journalAccountBalanceNow
            })
        })
     },

    /**
     * Ambil data dari journal dari server
     */
     getJournal(){
      this.$http.get(this.apiUrl.journal)
      .then((response) => {
        response.data._embedded.journal_account.forEach( b => {
          this.dataAccountName.push({
            value: b.uuid,
            text: b.journalAccountCode + ' ' + b.journalAccountName
          })
        })
      })
      .catch(error => {console.log(error);})
    },

    doPrint(){
        let url = this.apiUrl.exportLedger + '?start_date=' + this.model.startDate + '&end_date=' + this.model.endDate + '&journal_account=' + this.model.journalAccount + '&token=' + this.token

        window.open(url)
    },

    /**
   * formatter currency untuk data static
   */
   formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getDateTime(value) {
        if (value !== null) {
            return this.$moment(value).format('DD MMM YYYY');
        } else {
            return '-';
        }
     },

    }
}
</script>

<style>

</style>